__turbopack_context__.v({
  "active": "sidebar-module-scss-module__XVk0oG__active",
  "hasSubmenu": "sidebar-module-scss-module__XVk0oG__hasSubmenu",
  "level0": "sidebar-module-scss-module__XVk0oG__level0",
  "level1": "sidebar-module-scss-module__XVk0oG__level1",
  "level2": "sidebar-module-scss-module__XVk0oG__level2",
  "mobileOnly": "sidebar-module-scss-module__XVk0oG__mobileOnly",
  "sidebarHeader": "sidebar-module-scss-module__XVk0oG__sidebarHeader",
  "sidebarList": "sidebar-module-scss-module__XVk0oG__sidebarList",
  "sidebarWrapper": "sidebar-module-scss-module__XVk0oG__sidebarWrapper",
  "subMenu": "sidebar-module-scss-module__XVk0oG__subMenu",
});
